import { render, staticRenderFns } from "./ApplyRole.vue?vue&type=template&id=049c468a&scoped=true&"
import script from "./ApplyRole.vue?vue&type=script&lang=js&"
export * from "./ApplyRole.vue?vue&type=script&lang=js&"
import style0 from "./ApplyRole.vue?vue&type=style&index=0&id=049c468a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "049c468a",
  null
  
)

export default component.exports